import * as tslib_1 from "tslib";
import { ElementRef, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { Orientation } from './splitter-types';
var SplitterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SplitterComponent, _super);
    function SplitterComponent(_vcr) {
        var _this = _super.call(this, _vcr) || this;
        _this._leftWidth = null;
        _this._orientation = Orientation.Horiztonal;
        _this._topHeight = null;
        _this.isResizing = false;
        _this.previousMousePosition = null;
        return _this;
    }
    Object.defineProperty(SplitterComponent.prototype, "leftWidth", {
        get: function () {
            return this._leftWidth;
        },
        set: function (value) {
            this._leftWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitterComponent.prototype, "orientation", {
        get: function () {
            return this._orientation;
        },
        set: function (value) {
            this._orientation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitterComponent.prototype, "panelFirstSize", {
        get: function () {
            var panelAdjustSize = '100%';
            if (this.orientation === Orientation.Horiztonal) {
                panelAdjustSize = this.leftWidth ? this.leftWidth : '50%';
            }
            else {
                panelAdjustSize = this.topHeight ? this.topHeight : '50%';
            }
            return panelAdjustSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitterComponent.prototype, "panelLastSize", {
        get: function () {
            var panelLastSize = '100%';
            if (this.orientation === Orientation.Horiztonal) {
                panelLastSize = this.leftWidth ? 100 - Number(this.leftWidth.replace('%', '')) + "%" : '50%';
            }
            else {
                panelLastSize = this.topHeight ? 100 - Number(this.topHeight.replace('%', '')) + "%" : '50%';
            }
            return panelLastSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitterComponent.prototype, "topHeight", {
        get: function () {
            return this._topHeight;
        },
        set: function (value) {
            this._topHeight = value;
        },
        enumerable: true,
        configurable: true
    });
    SplitterComponent.prototype.getMouseEventDetails = function (mouseEvent) {
        return {
            clientX: mouseEvent.clientX,
            clientY: mouseEvent.clientY
        };
    };
    SplitterComponent.prototype.resize = function (mousePressEvent) {
        var _this = this;
        this.isResizing = true;
        this.previousMousePosition = {
            clientX: mousePressEvent.clientX,
            clientY: mousePressEvent.clientY
        };
        var resizeContainerBoundingBox = this.resizeContainer.nativeElement.getBoundingClientRect();
        var onMouseMove = function (mouseMoveEvent) {
            if (_this.orientation === Orientation.Horiztonal && mouseMoveEvent.clientX !== _this.previousMousePosition.clientX) {
                var mousePositionOffset = mouseMoveEvent.clientX - resizeContainerBoundingBox.left;
                var resizeHandleHorizontalBoundingBox = _this.resizeHandleHorizontal.nativeElement.getBoundingClientRect();
                var resizeHandleHorizontalOffset = void 0;
                var isResizeInsideContainer = void 0;
                var newPosition = void 0;
                if (mouseMoveEvent.clientX < _this.previousMousePosition.clientX) {
                    resizeHandleHorizontalOffset = resizeHandleHorizontalBoundingBox.left - resizeContainerBoundingBox.left;
                    isResizeInsideContainer = resizeContainerBoundingBox.left < resizeHandleHorizontalBoundingBox.left;
                    newPosition = Math.max(0, Math.min(mousePositionOffset, resizeHandleHorizontalOffset));
                }
                else {
                    resizeHandleHorizontalOffset = resizeHandleHorizontalBoundingBox.right - resizeContainerBoundingBox.right;
                    isResizeInsideContainer = resizeContainerBoundingBox.right > resizeHandleHorizontalBoundingBox.right;
                    newPosition = Math.min(resizeContainerBoundingBox.width - resizeHandleHorizontalBoundingBox.width, Math.max(mousePositionOffset, resizeHandleHorizontalOffset));
                }
                if (isResizeInsideContainer) {
                    _this.panelFirst.nativeElement.style.flexBasis = newPosition + "px";
                    _this.panelLast.nativeElement.style.flexBasis = resizeContainerBoundingBox.width - newPosition + "px";
                    _this.previousMousePosition = _this.getMouseEventDetails(mouseMoveEvent);
                }
            }
            else if (_this.orientation === Orientation.Vertical && mouseMoveEvent.clientY !== _this.previousMousePosition.clientY) {
                var mousePositionOffset = mouseMoveEvent.clientY - resizeContainerBoundingBox.top;
                var resizeHandleVerticalBoundingBox = _this.resizeHandleVertical.nativeElement.getBoundingClientRect();
                var resizeHandleVerticalOffset = void 0;
                var isResizeInsideContainer = void 0;
                var newPosition = void 0;
                if (mouseMoveEvent.clientY < _this.previousMousePosition.clientY) {
                    resizeHandleVerticalOffset = resizeHandleVerticalBoundingBox.top - resizeContainerBoundingBox.top;
                    isResizeInsideContainer = resizeContainerBoundingBox.top < resizeHandleVerticalBoundingBox.top;
                    newPosition = Math.max(0, Math.min(mousePositionOffset, resizeHandleVerticalOffset));
                }
                else {
                    resizeHandleVerticalOffset = resizeHandleVerticalBoundingBox.bottom - resizeContainerBoundingBox.bottom;
                    isResizeInsideContainer = resizeContainerBoundingBox.bottom > resizeHandleVerticalBoundingBox.bottom;
                    newPosition = Math.min(resizeContainerBoundingBox.height - resizeHandleVerticalBoundingBox.height, Math.max(mousePositionOffset, resizeHandleVerticalOffset));
                }
                if (isResizeInsideContainer) {
                    _this.panelFirst.nativeElement.style.flexBasis = newPosition + "px";
                    _this.panelLast.nativeElement.style.flexBasis = resizeContainerBoundingBox.height - newPosition + "px";
                    _this.previousMousePosition = _this.getMouseEventDetails(mouseMoveEvent);
                }
            }
        };
        var onMouseUp = function () {
            _this.isResizing = false;
            _this.previousMousePosition = null;
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };
    return SplitterComponent;
}(BaseComponent));
export { SplitterComponent };
